import { routes } from "../constants/routes";

/** Guarda en Redux solo datos serializables de la ruta (sin iconos React). */
export const serializeRouteForStore = (route) => {
  if (!route) return null;
  if (typeof route === "string") {
    return route in routes ? serializeRouteForStore(routes[route]) : null;
  }
  const { icon, action, ...rest } = route;
  return rest;
};
